<script setup lang="ts">
import { type NotivueItem } from 'notivue';
import BaseToast, { type NotivueItemProps } from './BaseToast.vue';

interface Props {
  item: NotivueItem<NotivueItemProps>;
}

defineProps<Props>();
</script>

<template>
  <BaseToast :item="item">
    <template #icon>
      <span
        :class="{ '!bg-system-warning-light p-1': item.title, 'h-full': !item.title }"
        class="flex items-center justify-center rounded-md"
      >
        <IconifyIcon
          :icon="
            item.title ? `heroicons:exclamation-triangle` : `heroicons:exclamation-triangle-solid`
          "
          class="size-6 text-system-warning-dark"
        ></IconifyIcon>
      </span>
    </template>
    <template #content>
      <h3 v-if="item.title" class="mb-1 text-base font-medium leading-4">
        {{ item.title }}
      </h3>
      <p
        :class="{ 'font-medium !text-system-warning-dark': !item.title }"
        class="text-sm text-semantic-link-secondary"
        :role="item.ariaRole"
        :aria-live="item.ariaLive"
        v-safe-html="item.message"
      />
    </template>
  </BaseToast>
</template>

<style scoped lang="scss"></style>
